// 接口管理
const interfaces = {
  login: '/login',
  sendMsg: '/sendMsg',
  queryBanner: '/queryBanner',
  queryCategory: '/queryCategory',
  queryCategoryVideos: '/queryCategoryVideos',
  queryVideoByCategoryId: '/queryVideoByCategoryId',
  queryVideo: '/queryVideo',
  queryQa: '/queryQa',
  settingRingOnePointMon: '/settingRingOnePointMon',
  getOrderList: '/getOrderList',
  unSubProductWithVCode: '/unSubProductWithVCode',
  delOrder: '/delOrder',
  sendVerifyCode: '/sendVerifyCode',
  qrySubedProducts: '/qrySubedProducts',
  queryRankSongList: '/api/v2/h5/rankSongList',
  favoriteSongList: '/api/v2/h5/ringtong/favorite/list',
  deleteFavoriteSong: '/api/v2/h5/ringtong/favorite/delete',

  checkMobile: '/checkMobile',
  getUserPhone: '/v1/user/phone',
  queryIntroduce: '/queryIntroduce',
  searchHints: '/search/hints',
  searchHots: '/search/hots',
  searchpages: '/search/searchpages',
  searchDetailById: '/search/searchDetail',
  searchRel: '/search/searchRel',
  channeladd: '/channel/add',
  actionlog: '/actionlog/add',
  queryConfig: '/config/query',
  queryRule: '/config/rule',
  queryTopicDraft: '/querySubjectDraft',
  queryTopic: '/querySubject',
  queryTopic2: '/querySubject2',
  queryRingRel: '/queryRingRel',
  queryRandom: '/queryRandom',

  queryHome: '/queryHome',
  diyUpload: '/diy/upload',
  diyBind: '/diy/bind',
  diyQuery: '/diy/query',
  diyDelete: '/diy/delete',
  diySetFile: '/diy/setFile'
}

export default interfaces
